import * as React from 'react'
import { Button, Form } from 'react-bootstrap'

import { copyObject, randomId } from '../../../../utils'
import InputDatePickerT from '../../../../components/InputDatePicker/InputDatePicker'
import NumberFormatValidate from '../../../../components/NumberFormatValidate'

import { VariablesObj, VariablesT, ListOptionsEstimate } from '../../../../types/Company'
import { resolveUnitLabel } from '../JobUtils'
import { parseFloatTotal } from '../Job'

import moment from 'moment'

import FormPaymentJob from '../../../../components/FormPaymentJob/FormPaymentJob'
import ButtonLoading from '../../../../components/ButtonLoading'
import { JobT, RevenueLineItemT } from '../../../../types/Job'
import PayByCard from '../../../../components/FormPaymentJob/PayByCard/PayByCard'

interface RevenueLineItemProps {
    job: JobT
    index: number
    lineItemDate?: string
    removeLineItem(category: string, index: number): void
    revenueLineItem: RevenueLineItemT
    updateLineItem(lineItemType: string, index: number, value: any): void
    companyVariables: VariablesT
    isPaid?: boolean
    refresh?(): Promise<void>
    saveJob(): Promise<string>
}


// Revenues:  labor, truck, packing, long carry, reimbursements
// Reimbursements: tolls, parking, equipment rental

const RevenueLineItem: React.FunctionComponent<RevenueLineItemProps> = (props): JSX.Element => {

    const [showFormPayment, setShowFormPayment] = React.useState(false)
    const [showAlertDelete, setShowAlertDelete] = React.useState(false);
    /**
     * 
     * @param key 
     * @param value 
     */
    const updateRevenueLineItem = (key: string, value: any): void => {
        let revenueLineItemClone = copyObject(props.revenueLineItem)

        if (!revenueLineItemClone?.isDirty) {
            revenueLineItemClone['isDirty'] = true
        }
        revenueLineItemClone[key] = value
        revenueLineItemClone = parseRevenueWithVariables(key, value, revenueLineItemClone)
        if (key == 'rate' || key == 'units') {
            revenueLineItemClone.total = revenueLineItemClone.rate * revenueLineItemClone.units
        }
        props.updateLineItem('revenue', props.index, revenueLineItemClone)
    }

    const parseRevenueWithVariables = (key: string, value: any, lineItem: RevenueLineItemT): RevenueLineItemT => {
        // update rate and units  pull in  settings  company if item exists
        if (key == 'item' && props.companyVariables[value]) {
            lineItem['rate'] = props.companyVariables[value].value
            lineItem.total = lineItem.rate * lineItem.units
        }
        return lineItem
    }

    /**
     * 
     */
    const ItemsOptions = (): Array<JSX.Element> => {
        if (props?.companyVariables) {
            return ListOptionsEstimate.map((li, index) => {
                return <option value={li} key={index}>{props.companyVariables[li].verboseName}</option>
            })
        }

    }
    return (
        <div>
            <div className="" style={{
                display: 'grid',
                gridTemplateColumns: '0.2fr 1fr 1fr 1fr 1fr 1fr 0.1fr',
                // gridTemplateColumns: props.isPaid ? '1fr 1fr 1fr 1fr 1fr 0.1fr' : '0.1fr 1fr 1fr 1fr 1fr 1fr 0.1fr'
            }}>
                <div className=" d-flex flex-row align-items-end" style={{ width: "100%" }}>

                    {(!showFormPayment) && <ButtonLoading className="btn btn-outline-primary"
                        disabled={props.isPaid}
                        style={{ paddingTop: 2, marginBottom: 8 }}
                        noShowResultMessageSuccess={true}
                        showSpinner={false}
                        onClickFetching={async (): Promise<string> => {
                            if (props.revenueLineItem.total <= 0) {
                                throw new Error("Please check and input correct fields!");
                            }
                            return props.saveJob().then((res) => {
                                setShowFormPayment(true)
                                return res;
                            })
                        }}>
                        {props.isPaid ? "Paid" : "Pay"}
                    </ButtonLoading>}
                    {showFormPayment && <button className="btn btn-light"
                        style={{ paddingTop: 2, marginBottom: 8 }}
                        onClick={() => {
                            setShowFormPayment(false)
                        }}>
                        Cancel
                    </button>}

                </div>
                <div className="">

                    <Form.Label>Date</Form.Label>
                    <InputDatePickerT

                        disabled={props.isPaid || showFormPayment}
                        id={`revenue-date-${props.index}`}
                        className="input-material"
                        style={{ width: '100%' }}
                        // selectedDate={`${fields.moveDate ? fields.moveDate : ""}`}
                        selectedDate={`${props.revenueLineItem.date ? props.revenueLineItem.date : ""}`}

                        onChangeDate={(val) => {
                            updateRevenueLineItem('date', val)

                        }}
                        onChange={(val) => {
                            // updateRevenueLineItem('date', val)

                        }}

                        dateFormat="MM/dd/yyyy"
                        placeholder="Date"
                    //value={moment(lineItemDate)}
                    // value={lineItemDate}
                    />
                </div>
                <div style={props.revenueLineItem.item == 'other' ? { display: 'grid', gridTemplateColumns: '1fr 2fr' } : {}}>
                    <div>
                        <Form.Label>Item</Form.Label>
                        <Form.Control
                            disabled={props.isPaid || showFormPayment}
                            as='select'
                            className='input-material'
                            onChange={(event: any): void => { updateRevenueLineItem('item', event.target.value) }}
                            value={props.revenueLineItem.item}>
                            {/* <option></option> */}
                            {ItemsOptions()}
                        </Form.Control>
                    </div>
                    {props.revenueLineItem.item == 'other' && <div>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            disabled={props.isPaid || showFormPayment}
                            className='input-material'
                            onChange={(event: any): void => { updateRevenueLineItem('other', event.target.value) }}
                            value={props.revenueLineItem.other} />
                    </div>}
                </div>
                <div>
                    <Form.Label>Rate{resolveUnitLabel(props.companyVariables, props.revenueLineItem.item, true)}</Form.Label>
                    {props.isPaid ?
                        <div style={{ backgroundColor: '#e9ecef', marginBottom: 7, padding: 5 }}>
                            <span className="text-success" style={{ fontWeight: 'bold' }}>${parseFloat(`${props.revenueLineItem.total}`).toFixed(2)} Paid</span>
                        </div> :
                        <NumberFormatValidate
                            disabled={props.isPaid || showFormPayment}
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${props.revenueLineItem.rate}`}
                            value={`${props.revenueLineItem.rate}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                if (floatValue != props.revenueLineItem.rate) {
                                    updateRevenueLineItem('rate', floatValue)
                                }
                            }}

                            // prefix={'$'}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            mask="_" />}
                </div>
                <div>
                    <Form.Label>Units{resolveUnitLabel(props.companyVariables, props.revenueLineItem.item, false)}</Form.Label>
                    <NumberFormatValidate
                        disabled={props?.isPaid || showFormPayment}
                        customInput={Form.Control}
                        className="input-material"
                        type="text"
                        defaultValue={`${props.revenueLineItem.units}`}
                        value={`${props.revenueLineItem.units}`}
                        onValueChange={(values) => {
                            const { formattedValue, value, floatValue } = values;
                            if (floatValue != props.revenueLineItem.units) {
                                updateRevenueLineItem('units', floatValue)
                            }
                        }}
                        mask="_"
                        fixedDecimalScale={true}
                        decimalScale={2}
                    />
                </div>
                <div>
                    <Form.Label>Total, $</Form.Label>
                    <Form.Control

                        className='input-material'
                        value={`${parseFloatTotal(props.revenueLineItem.total)}`}
                        disabled />
                    {/* <NumberFormatValidate
                    disabled={true}
                    customInput={Form.Control}
                    className="input-material"
                    type="text"
                    defaultValue={`${revenueLineItem.total}`}
                    value={`${revenueLineItem.total}`}
                    onValueChange={(values) => {
                        const { formattedValue, value, floatValue } = values;
                        if (floatValue != revenueLineItem.total) {
                            updateRevenueLineItem('total', floatValue)
                        }
                    }}
                    mask="_"
                    // prefix={'$'}
                    fixedDecimalScale={true}
                    decimalScale={2}
                /> */}
                </div>
                <div className="d-flex flex-row align-items-end" style={{ position: "relative", width: "100%", }}>

                    {!showAlertDelete && <div style={{ cursor: 'pointer', position: "absolute", right: 1, top: 1 }} onClick={(): void => {
                        // props.removeLineItem('revenue', props.index)
                        setShowAlertDelete(true)
                    }}>x</div>}


                </div>

            </div>

            <div>
                <div>

                    {showAlertDelete && <div className="alert alert-danger d-flex flex-column">

                        <span>Are you sure you want to delete this line item?</span>
                        <div className=" d-flex flex-row">
                            <Button variant="light" onClick={() => { setShowAlertDelete(false) }}>No</Button>
                            <button
                                type="button"

                                onClick={() => {
                                    props.removeLineItem('revenue', props.index)
                                }}
                                className="btn btn-outline-danger ">Yes</button>
                        </div>

                    </div>}
                </div>
                {/* {(!props.isPaid && !showFormPayment) && <ButtonLoading className="btn btn-outline-primary"
                    style={{ paddingTop: 2, marginBottom: 8 }}
                    noShowResultMessage={true}
                    onClickFetching={async (): Promise<string> => {
                        return props.saveJob().then((res) => {
                            setShowFormPayment(true)
                            return res;
                        })
                    }}>
                    Pay
                </ButtonLoading>} */}
                {/* {showFormPayment && <button className="btn btn-light"
                    style={{ paddingTop: 2, marginBottom: 8 }}
                    onClick={() => {
                        setShowFormPayment(false)
                    }}>
                    Cancel
                </button>} */}
            </div>
            {(showFormPayment) && <div>

                <PayByCard
                    productId={props.job.id}
                    userId={props.job.client.id}
                    productType={"jobs"}

                    paymentItems={[
                        {
                            productItem: props.revenueLineItem.item,
                            amount: props.revenueLineItem.total,
                            productItemId: props.revenueLineItem.id,
                            productRate: props.revenueLineItem.rate,
                            productUnits: props.revenueLineItem.units
                        }
                    ]}
                    onCompleteProcessing={(transaction) => {
                        if (props.refresh) {
                            props.refresh()
                        }

                        setShowFormPayment(false)
                    }}

                />
                {/* <FormPaymentJob
                    jobId={props.job.id}
                    amount={props.revenueLineItem.total}
                    userId={props.job.client.id}
                    productItemId={props.revenueLineItem.id}
                    productItem={props.revenueLineItem.item}
                    productRate={props.revenueLineItem.rate}
                    productUnits={props.revenueLineItem.units}
                    onCompleteProcessing={(transaction) => {
                        if (props.refresh) {
                            props.refresh()
                        }

                        setShowFormPayment(false)
                    }}
                /> */}

            </div>}
        </div>
    )
}

export default RevenueLineItem